import React from "react";
import Marquee from "react-fast-marquee";

// Text logo wall — dental associations / trust markers (editable).
const marks = [
  "ADA MEMBER PRACTICES",
  "AAO",
  "AACD",
  "GOOGLE PARTNER",
  "META BUSINESS PARTNER",
  "AGD",
  "INVISALIGN PROVIDERS",
];

export default function LogoWall() {
  return (
    <section className="py-14 md:py-16 border-y border-white/5 bg-white/[0.015]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 mb-8">
        <p className="text-center font-mono-accent text-[11px] uppercase tracking-[0.25em] text-white/40">
          Trusted across the profession we serve
        </p>
      </div>
      <div className="marquee-mask">
        <Marquee gradient={false} speed={22} pauseOnHover>
          {marks.concat(marks).map((m, i) => (
            <span
              key={i}
              className="mx-10 font-display text-lg md:text-xl tracking-wide text-white/35 hover:text-white/70 transition-colors duration-300"
            >
              {m}
            </span>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
